export const tableHeader = [
  {
    show:true,
    showFiled:'selection',//设置该字段是否在表头显示
    type:'selection',//渲染的表格行内数据类型
    width:'55',//表格列所占宽度
    label:'选择',//表格列名
    align:'center',//表格列数据对其方式
    fixed:false,//是否固定
  },
  {
    show:true,
    showFiled:'user_id',
    prop:'user_id',//字段
    label:'用户ID',//表格列名
    align:'center',//表格列数据对其方式
    width:'120',
    fixed:false,
  },
  {
    show:true,
    showFiled:'user_post_text',
    prop:'user_post_text',
    label:'提交文字',
    align:'center',
    width:'120',
    fixed:false,
  },
  {
    show:true,
    showFiled:'user_post_images',
    type:'image',
    prop:'user_post_images',
    label:'提交图片',
    align:'center',
    width:'120',
    fixed:false,
  },
  {
    show:true,
    showFiled:'price',
    prop:'price',
    label:'奖励金额',
    align:'center',
    width:'120',
    fixed:false,
    formatter:item =>{
    	return Number(item.price)/100 + '元'
    }
  },
  {
    show:true,
    showFiled:'commit_at',
    type:'date',
    prop:'commit_at',
    label:'提交时间',
    align:'center',
    width:'180',
    fixed:false,
    formatter:item =>{
      console.log(item,123)
    	if(item.commit_at == '' || item.commit_at == null){
        return '暂无'
      }
    }
  },
  {
    show:true,
    showFiled:'verify_at',
    type:'date',
    prop:'verify_at',
    label:'审核时间',
    align:'center',
    width:'180',
    fixed:false,
    formatter:item =>{
    	if(item.verify_at == '' || item.verify_at == null){
        return '暂无'
      }
    }
  },
  {
    show:true,
    showFiled:'reject_reason',
    prop:'reject_reason',
    label:'驳回原因',
    align:'center',
    width:'180',
    fixed:false,
  },
  {
    show:true,
    showFiled:'verify_left_time',
    prop:'verify_left_time',
    label:'审核剩余时长',
    align:'center',
    width:'120',
    fixed:false
  },
  {
    show:true,
    showFiled:'handle',
    type:'handle',
    width:'150',
    label:'操作',
    align:'center',
    fixed:'right'
  }
]